import React, { useState, useEffect } from "react";
import { Row, Col, Collapse, Image, Button } from "react-bootstrap";
import AddToCart from "../AddToCart/index";
import WeightOrDropDown from "../WeightOrDropDown/index";
import AttributeStack from "../../components/AttributeStack/index";
import { FaRupeeSign } from "react-icons/fa";
import "react-image-lightbox/style.css";
import Lightbox from "react-image-lightbox";
import AWS_CONSTANTS from "../../constants/aws";
import {
  getCartQuantityFromProductId,
  productPackagingInCart,
  getTotalQuantity,
  getWeightText,
  object_equals,
} from "../../helper";
import "./styles.scss";
import { isTablet } from "react-device-detect";

export default function ProductRow(props) {
  const {
    product,
    addToCart,
    isMobile,
    search,
    showPriceValue,
    cart,
    backend,
  } = props;
  const [showText, setShowText] = useState(isMobile ? true : false);
  const quantity = getCartQuantityFromProductId(cart, product);
  const [showAdditional, setShowAdditional] = useState(search ? true : false);
  const [productImageSrc, setProductImageSrc] = useState(null);
  const [productQuantity, setProductQuantity] = useState(quantity);
  const [newlyAdded, setNewlyAdded] = useState(false);
  let totalQuantity = getTotalQuantity(productQuantity);

  useEffect(() => {
    if (backend) {
      const quantity = getCartQuantityFromProductId(cart, product);
      if (product.rate_amt) {
        if (!object_equals(quantity, productQuantity)) {
          setProductQuantity(newlyAdded ? quantity : productQuantity);
          setNewlyAdded(false);
        }
      } else {
        if (!quantity !== productQuantity) {
          setProductQuantity(quantity);
        }
      }
    }
  }, [setProductQuantity, cart, product, productQuantity, backend, newlyAdded]);

  const getAddToCartButton = (quantity, packaging = null) => (
    <AddToCart
      element={product}
      addToCart={addToCart}
      cartQuantity={quantity}
      isMobile={isMobile}
      packaging={packaging}
      setProductQuantity={setProductQuantity}
      cart={cart}
      search={search}
      backend={backend}
      setNewlyAdded={setNewlyAdded}
    />
  );

  const getWeightOrDropdown = (packaging = null, setPackaging = null) =>
    !product.rate_amt ? (
      `${product.weight} ${product.unit}`
    ) : (
      <WeightOrDropDown
        product={product}
        productPackaging={product.product_packaging || []}
        selectedWeight={packaging}
        setSelectedWeight={setPackaging}
        search={search}
        productQuantity={productQuantity}
      />
    );

  const getAddMoreButton = () =>
    productQuantity.length > 0 &&
    productQuantity[productQuantity.length - 1].quantity > 0 && (
      <Row>
        <Col className="d-flex justify-content-center align-items-center">
          <Button
            style={{
              padding: ".175rem .5rem",
              fontSize: isMobile ? "3vw" : "0.75vw",
            }}
            variant="outline-warning"
            className="landing-button"
            onClick={(event) => {
              event.stopPropagation();
              const newProducts = Object.assign([], productQuantity);
              const packagingInCart = productPackagingInCart(productQuantity);
              const addPackaging = [];
              product.product_packaging.forEach(
                (e) => !packagingInCart.includes(e) && addPackaging.push(e)
              );
              newProducts.push({
                packaging: addPackaging[0],
                quantity: 0,
              });
              setProductQuantity(newProducts);
            }}
          >
            Add More
          </Button>
        </Col>
      </Row>
    );

  const getAddMoreDropDowns = () =>
    product.rate_amt ? (
      <Col sm={isTablet ? 8 : 4}>
        {!(productQuantity.length >= 1) ? (
          <Row>
            <Col className="d-flex justify-content-center">
              {getWeightOrDropdown(productQuantity[0].packaging, (value) => {
                const newProductQuantity = Object.assign([], productQuantity);
                newProductQuantity[0].packaging = value;
                setProductQuantity(newProductQuantity);
              })}
            </Col>
            <Col className="d-flex justify-content-center">
              {getAddToCartButton(
                productQuantity[0].quantity,
                productQuantity[0].packaging
              )}
            </Col>
          </Row>
        ) : (
          <>
            {productQuantity.map((element, index) => {
              return (
                <Row key={`${element.order_id}-${element.packaging}-${index}`}>
                  <Col className="d-flex justify-content-center">
                    {getWeightOrDropdown(element.packaging, (value) => {
                      const newProductQuantity = Object.assign(
                        [],
                        productQuantity
                      );
                      let packagingExists = false;
                      for (var i = 0; i < productQuantity.length; i++) {
                        if (element === productQuantity[i].packaging) {
                          packagingExists = true;
                        }
                      }
                      if (!packagingExists) {
                        newProductQuantity[index].packaging = value;
                        newProductQuantity[index].quantity = 0;
                        setProductQuantity(newProductQuantity);
                      } else {
                        newProductQuantity[index].packaging = value;
                        setProductQuantity(newProductQuantity);
                      }
                    })}
                  </Col>

                  <Col className="d-flex justify-content-center w-100">
                    {getAddToCartButton(
                      productQuantity[index].quantity,
                      productQuantity[index].packaging
                    )}
                  </Col>
                </Row>
              );
            })}
            {totalQuantity > 0 && (
              <Row className="justify-content-center mb-2">
                Cart Quantity: {getWeightText(totalQuantity)}
              </Row>
            )}
          </>
        )}
        {getAddMoreButton()}
      </Col>
    ) : (
      <>
        <Col
          sm={isTablet ? 4 : 2}
          className="d-flex justify-content-center align-items-center text-nowrap"
        >
          {getWeightOrDropdown()}
        </Col>
        <Col
          sm={isTablet ? 4 : 2}
          className="d-flex justify-content-center align-items-center w-100"
        >
          {getAddToCartButton(productQuantity)}
        </Col>
      </>
    );

  return (
    <Row
      className="product-row"
      sm={1}
      onClick={(event) => {
        if (!search) {
          event.stopPropagation();
          setShowAdditional(!showAdditional);
        }
      }}
    >
      <Col sm={showPriceValue ? 7 : isMobile ? 12 : 8}>
        <div
          className={`product-name d-flex ${
            isMobile ? "justify-content-center" : ""
          }`}
        >
          {product.product_name}
          <AttributeStack
            isMobile={isMobile}
            dietician_choice={product.dietician_choice}
            luxury_grade={product.luxury_grade}
            popular_choice={product.popular_choice}
          />
        </div>
        {!search && (
          <>
            <div
              className={`mt-2 ${
                isMobile
                  ? showAdditional
                    ? "justify-content-center"
                    : "d-none"
                  : "d-flex w-100 flex-wrap"
              }`}
            >
              <div className="d-flex text-center justify-content-center">
                {isMobile ? (
                  <Collapse in={showText}>
                    <p className="product-desciption">
                      {product.product_desc.slice(0, 60)}
                      <span>{product.product_desc.slice(60, -1)}</span>
                    </p>
                  </Collapse>
                ) : (
                  <p className="product-desciption">
                    {product.product_desc.slice(0, 60)}
                    <Collapse in={showText}>
                      <span>{product.product_desc.slice(60, -1)}</span>
                    </Collapse>
                  </p>
                )}
              </div>
              <div className="d-flex justify-content-center align-items-center">
                {product.product_desc.length >= 60 && (
                  <div className="d-flex align-items-center">
                    <p
                      className="ml-1 show-text"
                      onClick={(event) => {
                        event.stopPropagation();
                        setShowText(!showText);
                      }}
                    >
                      {showText
                        ? isMobile
                          ? "Hide Description"
                          : "Read less"
                        : isMobile
                        ? "View Description"
                        : "... Read more"}
                    </p>
                    <p className="ml-1"> | </p>
                  </div>
                )}
                <div
                  className="view-image-link ml-1"
                  onClick={(event) => {
                    event.stopPropagation();
                    setProductImageSrc(
                      `${AWS_CONSTANTS.ASSETS_URL}${product.image_src}`
                    );
                  }}
                >
                  Show Image
                </div>
              </div>
            </div>
            {isMobile && !showAdditional && product.listing_status && (
              <div className="d-flex justify-content-center">
                <Image
                  className="shop-more"
                  src={require("../../assets/icons/shop.gif")}
                />
              </div>
            )}
          </>
        )}
      </Col>
      {product.listing_status ? (
        isMobile ? (
          <>
            {showPriceValue === true && (
              <div
                className={`${
                  showAdditional
                    ? "d-flex justify-content-center mx-auto mt-1"
                    : "d-none"
                }`}
              >
                <FaRupeeSign
                  size={isMobile ? 13 : 18}
                  className="mr-1 ml-1 align-self-center"
                />
                {product.rate_amt
                  ? `${product.rate_amt}/KG`
                  : `${product.price_fixed}/Unit`}
              </div>
            )}
            <div
              className={
                isMobile
                  ? showAdditional
                    ? "d-flex w-100 mt-2 justify-content-center"
                    : "d-none"
                  : "d-flex"
              }
            >
              {getAddMoreDropDowns()}
            </div>
          </>
        ) : (
          <>
            {showPriceValue === true && (
              <Col sm={1} className="d-flex justify-content-center m-auto">
                <FaRupeeSign
                  size={isMobile ? 10 : 18}
                  className="mr-1 ml-1 align-self-center"
                />
                {product.rate_amt
                  ? `${product.rate_amt}/KG`
                  : `${product.price_fixed}/Unit`}
              </Col>
            )}
            {getAddMoreDropDowns()}
          </>
        )
      ) : (
        <Col
          className="d-flex justify-content-center align-items-center"
          sm={!isTablet && 4}
        >
          Out Of Stock
        </Col>
      )}
      {productImageSrc && (
        <div onClick={(event) => event.stopPropagation()}>
          <Lightbox
            mainSrc={productImageSrc}
            onCloseRequest={() => setProductImageSrc(null)}
            imageTitle={product.product_name}
            imageCaption={product.product_desc}
            imagePadding={isMobile ? 50 : 10}
            wrapperClassName="product-image"
          />
        </div>
      )}
    </Row>
  );
}
